__turbopack_context__.v({
  "content": "UspItemBlok-module__Z9_swa__content",
  "description": "UspItemBlok-module__Z9_swa__description",
  "root": "UspItemBlok-module__Z9_swa__root",
  "title": "UspItemBlok-module__Z9_swa__title",
});
